import { useCallback } from 'react'
import { Card, CardHeader, CardDetails } from '../Card'
import { CARD_WIDTH } from './Card'
import { useHistory } from 'react-router-dom'
import { CoreTypography } from '@thriveglobal/thrive-web-leafkit'

export type ExploreByTopicCardProps = {
    id?: string
    title?: string
    topicUrl?: string
    imageUrl?: string
    responsive?: boolean
    width?: CARD_WIDTH
    rootMargin?: string
    root?: null | Element
    threshold?: number
    backgroundColor?: string
    onClick?: () => void
    onEnter?: (entry: IntersectionObserverEntry) => void
}

export default function ExploreByTopicCard({
    id,
    title,
    topicUrl,
    imageUrl,
    responsive,
    width = CARD_WIDTH.small,
    rootMargin,
    root,
    threshold = 0.5,
    backgroundColor,
    onClick,
    onEnter
}: ExploreByTopicCardProps) {
    const history = useHistory()

    const handleOnClick = useCallback(() => {
        if (onClick) {
            onClick()
        }
        if (topicUrl) {
            history.push(topicUrl)
        }
    }, [onClick, topicUrl, history])

    return (
        <Card
            id={id}
            width={width}
            responsive={responsive}
            rootMargin={rootMargin}
            root={root}
            threshold={threshold}
            onClick={handleOnClick}
            onEnter={onEnter}
            imageSection={
                <CardHeader
                    imageSrc={imageUrl}
                    contrastCard
                    backgroundColor={backgroundColor}
                />
            }
            detailsHeight={36}
            detailsSection={
                <CoreTypography
                    variant="h5"
                    sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        m: -1
                    }}
                    data-testid="card-details-title"
                >
                    {title}
                </CoreTypography>
            }
        />
    )
}
